/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: 'AIzaSyCecvPN0hjV5g6Xkkr4Co8vn7P26bR1vq8',
    authDomain: 'bessalel-795bb.firebaseapp.com',
    databaseURL: 'https://bessalel-795bb.firebaseio.com',
    projectId: 'bessalel-795bb',
    storageBucket: 'bessalel-795bb.appspot.com',
    messagingSenderId: '757170849965',
    appId: '1:757170849965:web:c351ac941d16b51c01de24'
   // measurementId: “from firebase config”
  }
};

